export class MainStateAccessLayer {
  constructor(state) {
    this.state = state;
  }

  getBusinessIdea() {
    if (!this.state.businessIdea) {
      return '';
    }
    return this.state.businessIdea;
  }

  getSelectedTags() {
    return this.state.tags || [];
  }

  getIndustryText() {
    if (!this.state.industry) {
      return '';
    }
    return this.state.industry.industryText;
  }

  getOfficialIndustry() {
    if (!this.state.industry) {
      return '';
    }
    return this.state.industry.industry;
  }

  getCustomLabel() {
    if (!this.state.industry) {
      return false;
    }
    return this.state.industry.isCustom;
  }

  getIndustry() {
    return this.state.industry;
  }

  getPurposeChosen() {
    if (!this.state.purpose.purpose) {
      return [];
    }
    return this.state.purpose.purpose;
  }

  getScreenData() {
    return this.state.screenData;
  }

  getScreenType() {
    return this.state.screenData.type;
  }

  getReferralInfo() {
    return this.state.environment.referralInfo;
  }

  getNameslist() {
    if (!this.state.namesList) {
      return [];
    }
    return this.state.namesList;
  }

  isMobile() {
    let mobile = false;
    if (this.state.screenData.type === 'mobile') {
      mobile = true;
    }
    return mobile;
  }

  isDesktop() {
    let desktop = false;
    if (this.state.screenData.type === 'desktop') {
      desktop = true;
    }
    return desktop;
  }

  getBusinessDetails() {
    return this.state.businessDetails;
  }

  getSelectedIndex() {
    return this.state.selectedName.selectedIndex;
  }
}
